import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_QID_PRODUCT,
    StoreType,
    QidProductProps,
    LoadAllQidCompanies,
    LoadQidProductById,
    LoadDriveFolderByQidProductId,
    setQidCompanyList,
    setQidProductEdit,
    setQidProductFolderId,
    setQidProductReloadEdit,
    initQidProduct,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    productId = null,
}: QidProductProps) => {
    const product = useSelector((state: StoreType) => state.qidProduct.productEdit)
    const reloadEdit = useSelector((state: StoreType) => state.qidProduct.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        const promiseArray: Promise<any>[] = [
            LoadAllQidCompanies().then((res) => {
                dispatch(setQidCompanyList(res))
            }),
        ]

        if (productId === 0) {
            dispatch(setQidProductEdit(initQidProduct))
            dispatch(setQidProductFolderId(null))
        } else {
            promiseArray.push(
                LoadQidProductById(productId).then((res) => {
                    dispatch(setQidProductEdit(res))
                }),
                LoadDriveFolderByQidProductId(productId).then((res) => {
                    dispatch(setQidProductFolderId(res.id))
                }),
            )
        }

        setLoadState(PENDING)
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)

            dispatch(setQidProductReloadEdit(false))
            setTimeout(() => {
                dispatch(setQidProductReloadEdit(true))
            }, 0)
        })
    }, [])

    const addAccess = hasAccess(PRM_QID_PRODUCT, ADD)
    const editAccess = hasAccess(PRM_QID_PRODUCT, EDIT)

    if (productId === 0 && !addAccess) return <AccessDenied />
    if (productId !== 0 && !editAccess) return <AccessDenied />
    if (!product) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {product.id ? `${lang.editProduct} # ${product.id}` : lang.addProduct}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form product={product} />
                }
                {
                    reloadEdit
                    && <Form product={product} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
